import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsHT: CultureInfo = {
  name: 'es-HT',
  displayName: 'español (Haití)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-HT',
  parent: CultureInfoEs
};
